<template>
  <v-dialog v-model="show" persistent width="400" v-if="conf">
    <v-card>
      <v-card-title>
        <v-icon class="mr-2">mdi-account-plus-outline</v-icon>
        {{ $t('confr.inv.title') }}
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pb-0">
        <v-row>
          <v-col>
            <v-icon small>mdi-account-group</v-icon>
            <span class="conference-name">
              {{ confName }}
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0">
            <v-autocomplete
              v-model="invitee"
              :label="$t('confr.inv.label')"
              @keyup.enter="sendInvite"
              :search-input.sync="search"
              :loading="loading"
              :items="items"
              autofocus
              outlined
              hide-no-data
              clearable>
              <template v-slot:append-outer>
                <cp-help i18n="confr.inv" />
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel">
          {{ $t('confr.inv.cancel') }}
        </v-btn>
        <v-btn text color="primary darken-3"
          class="btn-invite"
          :disabled="!validValue"
          @click="sendInvite">
          {{ $t('confr.inv.invite') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import API from '@/api'
import events from 'Store/events'
import * as RMQClient from '@/rmqclient'

export default {
  name: 'conference-invite-member',
  data () {
    return {
      invitee: '',
      search: '',
      loading: false,
      items: []
    }
  },
  props: {
    conf: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      realm: 'sipua/realm',
      callerId: 'sipua/callerId'
    }),
    validValue: function () {
      return /^\d+$/.test(this.invitee) ||
        /^\d+$/.test(this.search)
    },
    confName: function () {
      if (this.conf.personal) {
        return `${this.$t('confr.personal.title.data')} <*99${this.conf.exten}>`
      }
      return `${this.conf.name} <${this.conf.exten}>`
    }
  },
  watch: {
    search (val) {
      if (!val) {
        this.items = []
        return
      }
      this.loadFromAPI(val)
    }
  },
  methods: {
    ...mapActions({
      setActive: 'conferences/setActive',
      memPaneShow: 'conferences/memPaneShow'
    }),
    cancel: function () {
      this.$emit('cancel')
      this.invitee = ''
    },
    loadFromAPI: function (pattern) {
      this.loading = true
      API.getPanelUsers(0, 11, pattern).then(resp => {
        const { data } = resp.data
        if (!data.length) {
          this.items = []
          return
        }
        this.items.splice(0)
        data.forEach(item => {
          this.items.push({
            text: `${item.exten} ${item.name}`,
            value: item.exten
          })
        })
      }).catch(err => {
        this.dbg(err)
        this.dbg(err.response)
        const msg = API.getException(err) ||
          'Failed to load users list from API'
        events.pubError(msg)
      }).finally(() => {
        this.loading = false
      })
    },
    sendInvite: function () {
      if (!this.validValue) return
      const dest = this.invitee || this.search
      const cmd = {
        action: 'Originate',
        channel: `Local/${dest}@confbridge-invite`,
        exten: `MEETME_${this.conf.confno}`,
        priority: '1',
        context: 'confbridge-join-member',
        callerid: this.callerId,
        amictx: 'confbridge',
        variable: {
          realm: this.realm,
          pin: this.conf.pin,
          confid: this.conf.id,
          invitee: dest
        }
      }
      RMQClient.sendCmd(cmd)
      this.invitee = ''
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
</style>
